import { useEffect, useState, useRef } from "react"
import { client_url, server_URL, getSS } from ".";

import TagMenu from "./TagMenu.js"

function TagView(){

  const [fatalerrormessage,setfatalerrormessage] = useState(null)
//   const [loadedtags,setloadedtags] = useState(null)

  const [tagmenudiv,settagmenudiv] = useState(null)
  const [popoutmessage,setpopoutmessage] = useState(null)

  
  const [visibleFileData,setVisibleFiledata] = useState([])
  const fetchedfiledata = useRef(null)
  const soretedDictData = useRef({})
  const userSelectedItems = useRef({})

  
  const itemsperrow = useRef(null)
  const thumbnailwidth = useRef(null)
  const contentDiv = useRef(null)
  const ScrollParentDiv = useRef(null)

  async function displaypopoutmessages(message){
    setpopoutmessage(
        <div style={{position:"absolute",left:"10%",top:"5px",right:"10%",fontWeight:"bold",fontSize:"15px",borderRadius:"5px",background:"lightgray",border:"1px solid black",display:"flex",justifyContent:"center",alignItems:"center"}}>
            <span style={{margin:"3px"}}>{message}</span>
        </div>
    )
    setTimeout(()=>{
        setpopoutmessage(null)
    },1500)
  }

  async function fetchrelatedcontents(){
      const loadedtags = getSS("tags")!==""?getSS("tags").split(","):[]
      if (loadedtags.length==0){
        return
      }



      const query = new URLSearchParams(window.location.search)
      const response = await fetch(server_URL()+"fetchcontentdata_tags",{
          "method":"POST",
          "headers":{
              "Content-Type":"application/json",
          },
          "body":JSON.stringify({
              "user_cache":query.get("cached"),
              "tags":loadedtags
          })
      })
      const output = await response.json()
      if(response.status!==200){
          setfatalerrormessage(output["message"])
          return
      }

      if (output["filedata"].length==0){
        setVisibleFiledata(
        <div style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",flexDirection:"column"}}>
            <span style={{fontFamily:"Roboto",fontSize:"14px",marginBottom:"10px",color:"red",textAlign:"center","fontWeight":"bold"}}>no content</span>
        </div>)
        return
      }
      
      fetchedfiledata.current = output["filedata"]

      const soretedDictArr = []
      const dict_temp = output["sortedDict"]
      for (const sortedDict of output["sortedDictOrder"]){
      soretedDictArr.push({
          "tagname":sortedDict,
          "itemsArr":dict_temp[sortedDict]
      })
      }
      soretedDictData.current = soretedDictArr

      
      formatdisplaydiv()
      whileScrolling()
  }


  const thumbnailHeight = 200
  const thumbnailMargin = 2
  const sortinglabelHeight = 25
  const sortinglabelMargin = 2

  function formatdisplaydiv(){ // set the format for the scroller to work
    const baseThumbnailWidth = 135
    const parentWidth = ScrollParentDiv.current.offsetWidth
    const IPR = parentWidth/(baseThumbnailWidth+thumbnailMargin*2) //itemsperrow
    const additionalWidth =  ((IPR - Math.trunc(IPR))*baseThumbnailWidth)/Math.trunc(IPR)
    thumbnailwidth.current = baseThumbnailWidth+additionalWidth
    if(fetchedfiledata.current==null||fetchedfiledata.current.length==0){
      return
    }
    itemsperrow.current = Math.floor(parentWidth/thumbnailwidth.current)
    let totalHeight = 0
    for (const sortedJSON of soretedDictData.current){
      sortedJSON["segmentRows"] = Math.ceil(sortedJSON["itemsArr"].length/itemsperrow.current)
      totalHeight+=(sortinglabelHeight+sortinglabelMargin*2)+sortedJSON["segmentRows"]*(thumbnailHeight+thumbnailMargin*2)
      sortedJSON["segmentLimit"] = totalHeight
    }
    contentDiv.current.style.height = totalHeight+sortinglabelMargin+"px"
  }
  function getTextWidth(text) {
    // Create a canvas element
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = "500 15px Inter, sans-serif";
    const metrics = context.measureText(text);
    return metrics.width; // width in pixels
  }
  function whileScrolling(){
    const currentScrolled = ScrollParentDiv.current.scrollTop

    let XINDEX = 0
    let YINDEX = 0
    let labelsAdded = 0

    const query_cached = new URLSearchParams(window.location.search).get("cached")
    const fileArr = []
    for(const itemDataJson of soretedDictData.current){
      const max = itemDataJson["segmentLimit"]
      const row = itemDataJson["segmentRows"]

      if(currentScrolled>max){
        YINDEX+=row
        labelsAdded+=1
        continue
      }
      fileArr.push(
        <div key={"sortinglabel_"+itemDataJson["tagname"]} style={{position:"absolute",height:sortinglabelHeight,fontFamily:"Roboto",fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",borderRadius:"10px",background:"rgba(48, 56, 56, 0.25)",left:sortinglabelMargin,right:sortinglabelMargin,top:sortinglabelMargin+YINDEX*(thumbnailHeight+thumbnailMargin*2)+(labelsAdded*(sortinglabelHeight+sortinglabelMargin*2))}}>
          <div style={{width:"10px"}}/>
          {itemDataJson["tagname"]}
        </div>
      )
      labelsAdded+=1

      for(const index of itemDataJson["itemsArr"]){
        if(XINDEX>=itemsperrow.current){
          XINDEX=0
        }
        const topvalue = sortinglabelMargin+YINDEX*(thumbnailHeight+thumbnailMargin*2)+(labelsAdded*(sortinglabelHeight+sortinglabelMargin*2))
        if(topvalue+thumbnailHeight+thumbnailMargin*2<currentScrolled){
          XINDEX+=1
          if(XINDEX>=itemsperrow.current){
            XINDEX=0
            YINDEX+=1
          }
          continue
        }
        const content = fetchedfiledata.current[index]
        if(content==null){
          return
        }
        let thumbnailname = content["thumbnailid"]
        let fileproperty = content["property"].split("/")[1]
        let parent_id = content["parent_id"]

        let contentdisplay = "center"
        let extramargin = 0
        const filedisplaytext = content["name"]+(content["type"]=="folder"?"":"."+fileproperty)
        if(getTextWidth(filedisplaytext)>=thumbnailwidth.current){
          contentdisplay = "left"
          extramargin = 2
        }

        const leftvalue = thumbnailMargin+XINDEX*(thumbnailwidth.current+thumbnailMargin)
        
        if(topvalue>currentScrolled+ScrollParentDiv.current.clientHeight){
          break
        }
        fileArr.push(
          <div key={content["id"]} style={{left:leftvalue,top:topvalue,cursor:"default",width:thumbnailwidth.current+"px",height:thumbnailHeight+"px",display:"flex",flexDirection:"column",position:"absolute",background:content["id"] in userSelectedItems.current?"rgba(118, 252, 252, 0.25)":""}} type = {content["type"]} id = {content["id"]} file_name={content["name"]} 
          onClick={(e)=>{
            const divJson = {
              "id":e.currentTarget.getAttribute("id"),
              "type":e.currentTarget.getAttribute("type"),
            }

            if (divJson["id"] in userSelectedItems.current){ // activate selected
              const query = new URLSearchParams(window.location.search)
              if(divJson["type"]==="folder"){
                window.location.href = client_url()+"App?cached="+query.get("cached")+"&folder="+divJson["id"]
              }
              else{
                window.location.href = client_url()+"viewer?cached="+query_cached+"&folder="+parent_id+"&fileid="+divJson["id"]
              }
              return
            }
            
            for (const [key, value] of Object.entries(userSelectedItems.current)) {
                const div = document.getElementById(value["id"])
                if(div !== null){
                div.style.background = ""
                }
            }
            e.currentTarget.style.background = "rgba(118, 252, 252, 0.25)"
            userSelectedItems.current[divJson["id"]] = divJson
          }}>
            <div className="largethumbnailcss">
              <img style={{position:"absolute",bottom:"0px",maxWidth:"90%",maxHeight:"75%",objectFit:"contain",display:content["type"]!="folder"?"none":"block"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Folderback.png"}></img>
              <img style={{maxWidth:"70%",maxHeight:"80%",objectFit:"contain",display:content["thumbnailid"]==""?"none":"block",zIndex:"10"}} draggable={false} src={server_URL()+"fetchthumbnail/"+query_cached+"/"+thumbnailname}></img>
              <img style={{position:"absolute",bottom:"0px",maxWidth:"90%",maxHeight:"75%",objectFit:"contain",display:content["type"]!="folder"?"none":"block",zIndex:"11"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Folderfront.png"}></img>
            </div>
            <div className="largefilenameviewcss" style={{textAlign:contentdisplay,marginLeft:extramargin}}>{filedisplaytext}</div>
          </div>
        )
        XINDEX+=1
        if(XINDEX>=itemsperrow.current){
          YINDEX+=1
        }
      }
      if(XINDEX<itemsperrow.current){
        YINDEX+=1
      }
      XINDEX = 0
      if(ScrollParentDiv.current.clientHeight+currentScrolled+thumbnailHeight+thumbnailMargin*2<max){
        break
      }
    }

    setVisibleFiledata(fileArr)
  }

  useEffect(()=>{
    const query = new URLSearchParams(window.location.search)
    if (query.get("cached")==null||query.get("cached")==""){
      setfatalerrormessage("cache invalid or expired, please login again")
      return
    }
    fetchrelatedcontents()
    if (ScrollParentDiv.current!==null){
      ScrollParentDiv.current.addEventListener("scroll",()=>{whileScrolling()})
    }
  },[])
  return(
    <div style={{position:"absolute",left:"0px",bottom:"0px",right:"0px",top:"0px",background:"burlywood"}}>
        <div style={{display:fatalerrormessage!=null?"flex":"none",position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",flexDirection:"column",zIndex:"1000"}}>
            <span style={{fontSize:"20px",marginBottom:"10px",color:"red",textAlign:"center"}}>{fatalerrormessage}</span>
            <a href={client_url()} style={{width:"100%",textAlign:"center"}} onClick={()=>{
              setSS("main_cached","")
            }}>home</a>
        </div>
        <div id="main_display" style={{width:"100%",height:"100%",overflow:"hidden",padding:"0px",display:fatalerrormessage==null?"flex":"none",flexDirection:"column"}}>
            <div style={{width:"100%",height:"35px",minHeight:"35px",background:"wheat",borderBottom:"1px solid black",display:"flex",alignItems:"center"}}>
                <div style={{width:"25px",height:"20px",cursor:"pointer",marginLeft:"5px"}} onClick={(e)=>{
                    settagmenudiv(
                        <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px",background:"rgba(0.5,0.5,0.5,0.5)",zIndex:"400"}}>
                            <img style={{position:"absolute",left:"5px",top:"5px",width:"20px",height:"20px",objectFit:"contain",background:"white",borderRadius:"5px",cursor:"pointer"}} src={server_URL()+"fetchcontent/gallery-assests/Cancel.png"} onClick={()=>{
                                settagmenudiv(null)
                            }}></img>
                            <TagMenu fileID={"sortbytags"} toClose={(message)=>{
                                settagmenudiv(null)
                                displaypopoutmessages(message)
                                fetchrelatedcontents()
                            }}/>
                        </div>
                    )
                }}>
                <img style={{width:"80%",height:"80%",objectFit:"contain"}} src={server_URL()+"fetchthumbnail/gallery-assests/Tag.png"}></img>
                </div>
            </div>
            <div ref={ScrollParentDiv} style={{display:"flex",width:"100%",height:"100%",overflowX:"hidden"}}>
                <div ref={contentDiv} style={{position:"relative",width:"100%"}}>
                    {visibleFileData}
                </div>
            </div>
            {tagmenudiv}
            {popoutmessage}
        </div>
    </div>
  )
}

export default TagView